import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "next/router";
import CardDetailLoader from "components/CardDetailLoader";
import SlimCTA from "components/SlimCTA";
import { createManifestWorkflow } from "actions/workflow";
import { fetchIntegrations } from "actions/integration";
import { useManifest } from "utils/selectors";
import { fetchWorkflows, updateWorkflow } from "actions/workflow";
import { fetchAppEntities } from "actions/app";
import {
  ensureWorkflows,
  ensureIntegrations,
  ensureAppVariables
} from "utils/hooks";
import { useCtxReferences } from "utils/selectors";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { BUTTON_TAGS } from "utils/constants/ui";
import WorkflowEditor from "components/WorkflowEditor";
import { prepareManifestVariables } from "utils/variable";
import { scaffoldWorkflow } from "utils/workflow";

const PageWorkflowsSection = ({ actions }) => {
  const { values } = useFormikContext();
  const { resource, resourceID, resourceUUID } = useCtxReferences();
  const uuid = get(values, "manifest.uuid");
  const manifest = useManifest(uuid, "uuid");

  const { loading: loadingWorkflows, workflows } = ensureWorkflows({
    fetchWorkflows: actions.fetchWorkflows
  });
  const { loading: loadingIntegrations } = ensureIntegrations({
    fetchIntegrations: actions.fetchIntegrations
  });
  const { loading: loadingAppVariables, variables } = ensureAppVariables();

  let workflow;
  /**
   * Note: if manifest has no workflows but they are expected the its workflow attribute is likely missing in the API response
   * - manifest.workflows should be a collection of associated workflow ids
   */
  const manifestHasWorkflow = Boolean(get(manifest, "workflows[0]"));
  if (manifestHasWorkflow) {
    workflow = workflows.find(({ id }) => id === manifest.workflows[0]);
  }
  const loading = Boolean(
    loadingWorkflows || loadingIntegrations || loadingAppVariables
  );

  let content;
  if (loading) {
    content = (
      <div className="mw8 center w-100 pt4">
        <CardDetailLoader />
      </div>
    );
  } else if (workflow && manifest && variables && variables.dynamic) {
    const preparedVars = prepareManifestVariables({
      manifest,
      variables: variables.dynamic
    });

    content = <WorkflowEditor workflow={workflow} variables={preparedVars} />;
  } else {
    content = (
      <div className="mw8 center w-100 pt4">
        <SlimCTA
          header="No workflows"
          subheader="Create a new workflow"
          actions={[
            {
              copy: "Create",
              tag: BUTTON_TAGS.BUTTON,
              onClick: () => {
                actions.createManifestWorkflow({
                  resource,
                  resourceID,
                  resourceUUID,
                  uuid,
                  data: scaffoldWorkflow({ title: manifest.title })
                });
              }
            }
          ]}
        />
      </div>
    );
  }

  return <div className="dib w-100 overflow-y-scroll">{content}</div>;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateWorkflow,
      fetchWorkflows,
      fetchAppEntities,
      fetchIntegrations,
      createManifestWorkflow
    },
    dispatch
  )
});

export default withRouter(
  connect(null, mapDispatchToProps)(PageWorkflowsSection)
);
